var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtrOptimaBlueSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 308.079,
    height: 213.268,
    viewBox: "0 0 308.079 213.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M168.635,113.471c-48.16-4.631,32.03-86.049-12.607-99.471,10.615,30.642-34.622,98.621,12.607,99.471",
    transform: "translate(-146.658 -14)",
    fill: "#186eb1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M160.92,114.938c-42.391-10.573,11.181-68.67-29.256-81.362,12.8,28.02-10.195,78.543,29.256,81.362",
    transform: "translate(-131.664 -33.576)",
    fill: "#186eb1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M155.165,121.072c9.423-.367,13.147-2.546,20.655-7.608,3.843-2.594,7.474-1.48,11.841-.367a29.191,29.191,0,0,0,9.386,1.177c-8.884-.218-12.321-8.989-20.968-4.286-6.7,3.647-11.795,8.308-23.879,5.644-5.5-1.208-9.47-3.438-13.97-8.922-.124-.144-.247-.3-.365-.453-10.592-13.681-5.141-44-5.141-44-21.164,31.83-6.424,59.915,22.441,58.811",
    transform: "translate(-122.718 -62.261)",
    fill: "#186eb1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(0.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(118.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M168.635,113.471c-48.16-4.631,32.03-86.049-12.607-99.471,10.615,30.642-34.622,98.621,12.607,99.471",
    transform: "translate(-146.658 -14)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M196-7.7l32.59,113.436L128.275,135.168,95.684,21.732Z",
    transform: "translate(-146.658 -14)",
    fill: "#186eb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(103.665 19.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M160.92,114.938c-42.391-10.573,11.181-68.67-29.256-81.362,12.8,28.02-10.195,78.543,29.256,81.362",
    transform: "translate(-131.664 -33.576)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M166.58,17.116l30,89.436L124.05,131.4l-30-89.436Z",
    transform: "translate(-131.664 -33.576)",
    fill: "#186eb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(94.719 48.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M155.165,121.072c9.423-.367,13.147-2.546,20.655-7.608,3.843-2.594,7.474-1.48,11.841-.367a29.191,29.191,0,0,0,9.386,1.177c-8.884-.218-12.321-8.989-20.968-4.286-6.7,3.647-11.795,8.308-23.879,5.644-5.5-1.208-9.47-3.438-13.97-8.922-.124-.144-.247-.3-.365-.453-10.592-13.681-5.141-44-5.141-44-21.164,31.83-6.424,59.915,22.441,58.811",
    transform: "translate(-122.718 -62.261)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M117.577,40.165l94.637,26.313L191.03,144.272,96.394,117.959Z",
    transform: "translate(-122.718 -62.261)",
    fill: "#186eb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(0 80.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M98.97,115.938C82.94,99.314,67.051,84.184,28,105.182,55.62,97.289,78.465,106,98.97,115.938",
    transform: "translate(-27.999 -94.926)",
    fill: "#186eb1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M177.215,123.64c-25.925,22.236-49.844,6.071-78.244-7.7,22.623,24.043,57.4,41.093,83.376,8.476,3.7-4.642,7.68-8.8,15.653-9.127,0,0-8.6-2.1-20.785,8.352",
    transform: "translate(-27.999 -94.926)",
    fill: "#186eb1",
    fillRule: "evenodd"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 118.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M66.082,132.964q16.332,0,26.377,9.854t10.048,25.873q0,17.426-10.363,29.535Q82.045,210.06,64.3,210.062q-16.956,0-27.108-10.291t-10.152-27.5a44.042,44.042,0,0,1,2.564-14.687,36.259,36.259,0,0,1,6.959-12.246,34.573,34.573,0,0,1,12.9-9.089,42.442,42.442,0,0,1,16.615-3.288m-3.767,4.067q-10.52,0-16.432,8.087t-5.915,22.516q0,17.035,7.432,27.7t19.31,10.662a20.218,20.218,0,0,0,17.166-8.819q6.437-8.814,6.437-23.574a47.8,47.8,0,0,0-2.983-16.629,33.6,33.6,0,0,0-7.955-12.885,23.6,23.6,0,0,0-17.06-7.056",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M108.572,214.864v-37l.1-2.272-.261-2.38a4.082,4.082,0,0,0-4.189-3.247,10.963,10.963,0,0,0-1.1.056l-.472.055q-1.047-.056-1.047-1.275a1.246,1.246,0,0,1,1.047-1.383l2.461-.382q6.7-1.139,10.1-3.688a11.168,11.168,0,0,1,3.075-1.9q.744,0,.849,1.2l.052,1.581V168.6c.208.765.558,1.168,1.047,1.2a1.909,1.909,0,0,0,.888-.491,46.291,46.291,0,0,1,7.6-5.357,13.886,13.886,0,0,1,6.089-1.205,16.38,16.38,0,0,1,12.88,5.666q4.989,5.661,4.991,14.6,0,12.948-7.838,20.807-6.271,6.291-13.637,6.287-6.848,0-10.347-1.761a2.325,2.325,0,0,0-.94-.276c-.525,0-.784.669-.784,2v4.771q0,4.815,1.647,6.768t6.15,2.492q1.989.225,1.989,1.494c0,1.173-.56,1.727-1.677,1.655a10.472,10.472,0,0,1-1.89-.327,30.075,30.075,0,0,0-7.079-1.03q-1.888,0-5.663.27l-4.511.382q-1.627.106-2.2.107c-1.33,0-1.994-.519-1.994-1.548,0-.66.453-1.16,1.36-1.492A4.273,4.273,0,0,0,108,221.3q.574-1.517.576-6.437m10.571-39.172V196.7q0,3.515,4.263,6.592a15.4,15.4,0,0,0,9.187,3.079,9.706,9.706,0,0,0,8.269-4.264q3.086-4.271,3.088-11.4a23.344,23.344,0,0,0-4.66-14.721q-4.656-6.021-11.409-6.022a11.04,11.04,0,0,0-6.175,1.676,4.815,4.815,0,0,0-2.563,4.051",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M167.806,169.534V196.01q0,4.83,1.387,6.727t4.892,1.9a12.557,12.557,0,0,0,3.638-.735,10.114,10.114,0,0,0,3.166-1.472,1.726,1.726,0,0,1,.839-.45q.627,0,.783,1.11l.106.549-.629.944a18.835,18.835,0,0,1-13.375,5.48q-5.873,0-8.625-2.761t-2.754-8.563v-29.2h-3.191q-2.514,0-2.514-1.434,0-.882,1.316-1.823a48.145,48.145,0,0,0,6.459-6.022,46.968,46.968,0,0,0,5.622-6.78q1.625-2.66,2.409-2.607c.279.039.436.309.471.817V164.27H175.4a5.013,5.013,0,0,0,2.982-.7l1.362-.926a1.821,1.821,0,0,1,.94-.378c.594-.037.873.255.839.872a4.212,4.212,0,0,1-.368,1.2,10.887,10.887,0,0,0-.627,2.4q-.576,2.794-2.878,2.792Z",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M196.111,165.076v30.685q0,5.526,1.6,7.687t5.938,2.435c1.152.075,1.728.5,1.728,1.274q0,1.441-4.144,1.44-.523,0-2.255-.151l-3.932-.411c-2.167-.2-3.6-.307-4.3-.307a50.375,50.375,0,0,0-7.5.76,10.311,10.311,0,0,1-1.781.22c-.735,0-1.1-.355-1.1-1.059a1.212,1.212,0,0,1,.68-1.11l1.779-.922a4.913,4.913,0,0,0,1.963-2.816,13.454,13.454,0,0,0,.811-4.654l-.052-2.271V177.539q0-4.217-.863-5.841a3.213,3.213,0,0,0-3.114-1.622h-1.2a1.7,1.7,0,0,1-1.36-.441,1.375,1.375,0,0,1-.158-.775q0-1.372,3.2-2.1,7.981-1.735,12.549-5.262a1.85,1.85,0,0,1,.889-.38q.732.054.733,1.028l-.054.488c-.033.325-.052,1.137-.052,2.437",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M277.485,182.853v15.121q0,4.17,1.279,5.824c.857,1.1,2.5,1.8,4.949,2.085q1.83.279,1.829,1.5,0,1.436-1.571,1.436a56.463,56.463,0,0,1-7.45-.923,32.606,32.606,0,0,0-4.511-.431,39.957,39.957,0,0,0-6.659.811,13.433,13.433,0,0,1-2.151.272c-.63,0-.946-.368-.946-1.11,0-.517.369-.995,1.1-1.439a7.987,7.987,0,0,0,2.957-2.3,6.95,6.95,0,0,0,.654-3.489l-.052-2.6V182.84q0-7.411-2.381-10.876t-7.459-3.461a9.243,9.243,0,0,0-6.437,2.272,7.523,7.523,0,0,0-2.511,5.842v19.53q0,5.306,1.491,7.358t5.573,2.489q1.937.163,1.937,1.38,0,1.55-1.94,1.547a60.076,60.076,0,0,1-7.447-.759,43.91,43.91,0,0,0-5.508-.434,35.743,35.743,0,0,0-5.61.707,22.626,22.626,0,0,1-2.361.273q-1.416.053-1.416-1.22a1.359,1.359,0,0,1,.836-1.334,6.636,6.636,0,0,0,3.168-2.405,9.422,9.422,0,0,0,.758-4.409l-.052-2.272V183.057q0-7.416-2.25-10.875t-7.012-3.461a9.231,9.231,0,0,0-9.526,9.522v19.581q0,3.9,1.414,5.409t6.019,2.7c1.081.261,1.639.739,1.675,1.441.033.85-.561,1.272-1.785,1.272q-1.312,0-2.988-.162l-4.723-.543a48.7,48.7,0,0,0-5.19-.323,26.174,26.174,0,0,0-6.243.705,9.223,9.223,0,0,1-2.1.323q-1.47,0-1.469-1.329c0-.483.33-.87.993-1.167a6.471,6.471,0,0,0,2.931-2.516,8.624,8.624,0,0,0,.838-4.187l.051-2.87V177.216q0-4.815-.993-6.167t-4.556-1.353q-1.305,0-1.307-1.16c0-.887.876-1.491,2.627-1.824l4.251-1.357,2.995-.976a23.17,23.17,0,0,0,5.985-3.2,1.269,1.269,0,0,1,.733-.328q.835-.056.837,1.2l-.052,1.354-.158,3.634c-.035.4-.051.816-.051,1.25q0,2.115.892,2.169c.208,0,.454-.162.732-.49l2.152-2.547a13.98,13.98,0,0,1,11.008-5.155,13.517,13.517,0,0,1,7.261,2.441q3.8,2.442,4.849,5.317c.419,1.156.716,1.737.89,1.737s.526-.362,1.052-1.086a20.067,20.067,0,0,1,6.658-6.1,16.084,16.084,0,0,1,8.019-2.306q15.463,0,15.467,20.59",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M307.724,182.663a19.213,19.213,0,0,0,.579-4.245,14.623,14.623,0,0,0-2.519-8.862,7.7,7.7,0,0,0-6.465-3.441q-5.043,0-5.043,4.318a11.011,11.011,0,0,0,.106,1.564l.155,1.027q0,3.674-8.1,3.672-2.109,0-2-1.9a4.351,4.351,0,0,1,.263-1.2c.106-.4.209-.87.314-1.411a8.272,8.272,0,0,1,3.192-5.315,21.828,21.828,0,0,1,13.4-4.125q9.051,0,13.554,4.337,3.459,3.3,3.457,11.485,0,4.122-.315,10.35-.314,7.152-.316,9.537,0,5.581,4.294,5.583a5.088,5.088,0,0,0,2.247-.382,3.489,3.489,0,0,1,1.2-.38c.489,0,.733.252.733.762q0,1.356-2.039,2.547l-2.04,1.085-1.781,1.085a8.491,8.491,0,0,1-4.134,1.032q-4.605,0-7.747-6.185-9.732,6.457-16.172,6.456a9.091,9.091,0,0,1-6.956-2.666A10.337,10.337,0,0,1,283.078,200q0-8.591,7.206-12.5,4.437-2.337,17.44-4.839m-1.047,3.146q-4.5-.327-8.581,3.31t-4.081,7.977q0,7.16,5.547,7.159a10.716,10.716,0,0,0,6.019-1.68,4.592,4.592,0,0,0,1.935-2.985,32.75,32.75,0,0,0,.524-7l.053-4.177v-1.138l-.316-1.2a2.123,2.123,0,0,0-1.1-.27",
    transform: "translate(-27.043 -132.964)",
    fill: "#186eb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(156.286 7.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M197.351,147.9a7.011,7.011,0,1,1-7.01-7.073,7.04,7.04,0,0,1,7.01,7.073",
    transform: "translate(-183.329 -140.823)",
    fill: "#186eb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(294.715 15.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M321.758,148.755",
    transform: "translate(-321.758 -148.755)",
    fill: "#186eb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(292.652 19.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M335.122,160.378a7.716,7.716,0,1,1-7.69-7.507A7.544,7.544,0,0,1,335.122,160.378Zm-13.5,0a5.817,5.817,0,0,0,5.86,6,5.748,5.748,0,0,0,5.721-5.951,5.795,5.795,0,1,0-11.581-.046Zm4.623,3.936H324.5v-7.506a15.119,15.119,0,0,1,2.884-.23,4.68,4.68,0,0,1,2.609.55,2.08,2.08,0,0,1,.733,1.647,1.926,1.926,0,0,1-1.557,1.741v.091a2.217,2.217,0,0,1,1.373,1.831,5.7,5.7,0,0,0,.55,1.876h-1.877a6.432,6.432,0,0,1-.6-1.831c-.137-.823-.6-1.189-1.556-1.189h-.824Zm.046-4.256h.824c.961,0,1.74-.321,1.74-1.1,0-.687-.5-1.145-1.6-1.145a4.147,4.147,0,0,0-.961.092Z",
    transform: "translate(-319.695 -152.871)",
    fill: "#186eb1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtrOptimaBlueSolid);
export default __webpack_public_path__ + "static/media/OTR_optima_blue_solid.1e85fe97babeba85d84b925f85982348.svg";
export { ForwardRef as ReactComponent };